import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SnackBarService } from '../../../../app/common-services/snack-bar.service';
import { SharedService } from '../../../../app/shared/shared.service';
import { ApiResponse } from '../../../common-services/models.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationHeader } from '../../../common-services/enum.service';
import { ButtonType } from '../../../common-component/confirmation-popup/confirmation-popup.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-sales-return-request',
  templateUrl: './sales-return-request.component.html',
  styleUrls: ['./sales-return-request.component.css']
})
export class SalesReturnRequestComponent implements OnInit {

  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = [];
  hasSelection = false;

  constructor(
   private route: ActivatedRoute,
    public router: Router,
    public sharedService: SharedService,
    private notification: SnackBarService
  ) {}

  ngOnInit(): void {

    this.route.data.subscribe((res) => {
      const resolverData = res['data'];
      if (resolverData && resolverData.length > 0) {
        const tableData = resolverData[0].data.getData;
       this.hasSelection = resolverData[0].data.isApprove[0].isApprove;
        this.dataSource = new MatTableDataSource(tableData);
        // Generate columns dynamically
        if (tableData.length > 0) {
          this.displayedColumns = Object.keys(tableData[0]).filter(col => col !== 'headerId');
        }
        this.dataSource.paginator = this.paginator;
      }
    });
  }

  OnApprove(): void {
    this.confirmAndUpdate(true, 'Are you sure you want to approve this request?');
  }

  OnReject(): void {
    this.confirmAndUpdate(false, 'Are you sure you want to reject this request?');
  }

  private confirmAndUpdate(status: boolean, message: string): void {
    const confirmDialog = this.sharedService.getConfirmatonConfig(
      ConfirmationHeader.Confirmation,
      message,
      ButtonType.YesNo
    );

    confirmDialog.afterClosed().subscribe(confirm => {
      if (!confirm) return;

      const payload = {
        Status: status,
        HeaderId: this.dataSource.filteredData[0].headerId,
      };

      this.updateStatus(payload);
    });
  }
  private updateStatus(payload: any): void {
    this.sharedService
      .customPostApi('salesreturnapproval/updatestatus', payload)
      .subscribe((response: ApiResponse) => {

        if (response.status) {
          this.notification.success(response.message);
          this.router.navigateByUrl('/report/view/205');

        } else {
          this.notification.warning(response.message);
        }
      });
  }
    onClear() {
    this.router.navigateByUrl('/report/view/205');
  }
   /**
 * Converts API column keys into user-friendly table headers.
 * Examples:
 *   sr_No → "Sr No"
 * Logic:
 * 1. Replace all underscores (_) with spaces for readability.
 * 2. Convert the first letter of every word to uppercase (Title Case).
 * This function is fully dynamic and works for any column key returned by the API.
 */
  formatHeader(key: string): string {
    if (!key) return '';
    return key
      .replace(/_/g, ' ')                     // Step 1: Replace "_" with space
      .replace(/\b\w/g, c => c.toUpperCase()); // Step 2: Capitalize each word
  }
}
